require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./truncatedtext"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./truncatedtext"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./truncatedtext")) : factory(root["./utils"], root["./truncatedtext"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__17__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[8],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(169);


/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Checkbox = _interopRequireDefault(__webpack_require__(170));

exports["default"] = _Checkbox["default"];
exports.Checkbox = _Checkbox["default"];

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _baUiCarbon = __webpack_require__(12);

var _truncatedtext = _interopRequireDefault(__webpack_require__(17));

var _Checkbox = _interopRequireDefault(__webpack_require__(171));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var checkboxClassName = _Checkbox["default"].checkboxClassName.replace(/"/g, '');

var BaPropTypes = _utils.propsUtils.BaPropTypes;
var uniqueId = _utils.lodash.uniqueId;

var Checkbox = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Checkbox, _Component);

  function Checkbox() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (node) {
      _this._inputNode = node;
    });
    return _this;
  }

  var _proto = Checkbox.prototype;

  // Internet Explorer only fires the onchange event when the checkbox loses the focus (onblur).
  // For components like checkbox, onClick is preferred.
  _proto.focus = function focus() {
    this._inputNode && this._inputNode.focus();
  };

  _proto.render = function render() {
    var _ref;

    var _this$props = this.props,
        className = _this$props.className,
        id = _this$props.id,
        labelText = _this$props.labelText,
        onClick = _this$props.onClick,
        onTouchStart = _this$props.onTouchStart,
        tabIndex = _this$props.tabIndex,
        wrapperClassName = _this$props.wrapperClassName,
        active = _this$props.active,
        align = _this$props.align,
        hover = _this$props.hover,
        label = _this$props.label,
        labelExtraOptions = _this$props.labelExtraOptions,
        readOnly = _this$props.readOnly,
        visual = _this$props.visual,
        otherCarbonCheckboxProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["className", "id", "labelText", "onClick", "onTouchStart", "tabIndex", "wrapperClassName", "active", "align", "hover", "label", "labelExtraOptions", "readOnly", "visual"]);
    var _CarbonCheckbox$defau = _baUiCarbon.Checkbox.defaultProps,
        onClickDefault = _CarbonCheckbox$defau.onClick,
        onTouchStartDefault = _CarbonCheckbox$defau.onTouchStart;
    var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    var classNamesCX = (0, _utils.classnames)(checkboxClassName, {
      visual: visual
    });
    var mappedClassName = wrapperClassName && className ? className : undefined;
    var mappedId = id || uniqueId('__checkbox_');
    var mappedLabelText = labelText != null ? labelText : label ? /*#__PURE__*/_react["default"].createElement(_truncatedtext["default"], {
      value: label
    }) : undefined;
    var mappedOnClick = iOS || onClick === onClickDefault ? undefined : onClick;
    var mappedOnTouchStart = !iOS || onClick === onClickDefault && onTouchStart === onTouchStartDefault ? undefined : onTouchStart != null ? onTouchStart : onClick;
    var mappedTabIndex = visual ? -1 : tabIndex;
    var mappedWrapperClassName = classNamesCX + " " + ((_ref = wrapperClassName != null ? wrapperClassName : className) != null ? _ref : '');
    return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Checkbox, (0, _extends2["default"])({}, otherCarbonCheckboxProps, labelExtraOptions != null ? labelExtraOptions : {}, {
      className: mappedClassName,
      id: mappedId,
      labelText: mappedLabelText,
      onTouchStart: mappedOnTouchStart,
      onClick: mappedOnClick,
      ref: this._ref,
      tabIndex: mappedTabIndex,
      wrapperClassName: mappedWrapperClassName
    }));
  };

  return Checkbox;
}(_react.Component);

exports["default"] = Checkbox;
(0, _defineProperty2["default"])(Checkbox, "propTypes", (0, _extends2["default"])({}, _baUiCarbon.Checkbox.propTypes, {
  /** deprecated - not supported in Carbon */
  active: BaPropTypes.deprecated('deprecated - not supported in Carbon'),

  /** deprecated - not supported in Carbon */
  align: BaPropTypes.deprecated('deprecated - not supported in Carbon'),

  /** deprecated - not supported in Carbon */
  hover: BaPropTypes.deprecated('deprecated - not supported in Carbon'),

  /** deprecated - use labelText */
  label: BaPropTypes.deprecated('deprecated - use labelText'),

  /** deprecated - just pass in the props */
  labelExtraOptions: BaPropTypes.deprecated('deprecated - just pass in the props'),

  /** deprecated - no Carbon option(maybe disabled) */
  readOnly: BaPropTypes.deprecated('deprecated - no Carbon option(maybe disabled)'),

  /** prop is used to ignore pointer events like clicks in scss. deprecated - no Carbon option(apply style={pointerEvents: none} to a tag wrapping this widget */
  visual: BaPropTypes.deprecated('deprecated - no Carbon option(apply style={pointerEvents: none} to a tag wrapping this widget)')
}));

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(172);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-checkbox.is-visual{pointer-events:none}\n", ""]);

// exports
exports.locals = {
	"checkboxClassName": "\"ba-common-checkbox\""
};

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[168,0]]]);
});